// require('bootstrap/js/src/util.js');
// require('bootstrap/js/src/alert.js');
// require('bootstrap/js/src/button.js');
// require('bootstrap/js/src/carousel.js');
require('bootstrap/js/src/collapse.js');
require('bootstrap/js/src/dropdown.js');
require('bootstrap/js/src/modal.js');
// require('bootstrap/js/src/scrollspy.js');
require('bootstrap/js/src/tab.js');
// require('bootstrap/js/src/tooltip.js');
// require('bootstrap/js/src/popover.js');
require('bootstrap-select/js/bootstrap-select');
require('bootstrap-datepicker');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.de');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.en-AU');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.en-CA');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.en-GB');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.en-IE');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.en-NZ');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.en-ZA');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.es');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.fr');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.fr-CH');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.it');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.it-CH');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.ja');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.ru');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.zh-CN');
